import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientDataForAppoinment } from './service/make-appoinment.model';
import { PatientService } from 'src/app/layouts/private-layout/pages/patients/services/patient.service';
import { Patient } from 'src/app/layouts/private-layout/pages/patients/services/patient.model';
import { CaseType } from 'src/app/enums/enums';

@Component({
  selector: 'app-make-appointment-dialogue',
  templateUrl: './make-appointment-dialogue.component.html',
  styleUrls: ['./make-appointment-dialogue.component.scss']
})
export class MakeAppointmentDialogueComponent {
  active = 1;
  activeModal = inject(NgbActiveModal);
  loading = false;
  patientData: PatientDataForAppoinment = {
    id: 0,
    name: '',
    caseName: '',
    da: '',
    de: '',
    clinicId: 0,
    isDischarged: false
  };
  isMdData: boolean = false;
  isMRIData: boolean = false;

  @Input() data: any;
  constructor(private patientService: PatientService) {}

  ngOnInit() {
    const response = this.patientService.GetPatient(this.data.id || this.data.patientId);
    this.loading = true;
    response.subscribe({
      next: (res: { result: Patient }) => {
        this.patientData.id = res.result.id || 0;
        this.patientData.name = `${res.result.lastName} ${res.result.firstName}`;
        this.patientData.caseName = CaseType[res.result.caseType];
        this.patientData.da = res.result.dateOfAccident;
        this.patientData.de = res.result.dateOfEntry;
        this.patientData.clinicId = res.result.clinicId;
        this.patientData.isDischarged = res.result.isDischarged;
      },
      error: () => {
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
}
